var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHeartRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.07 20.9a5.541 5.541 0 0 1-1.42-3.7c0-3.06 2.49-5.55 5.55-5.55 1.54 0 2.97.62 4.04 1.74a.7.7 0 0 1 .08.1c.94 1.06 1.43 2.35 1.43 3.7 0 3.07-2.49 5.56-5.55 5.56-1.57 0-3.07-.67-4.13-1.85zm.08-3.7c0 .99.37 1.95 1.04 2.7a4.05 4.05 0 0 0 3.01 1.35c2.23 0 4.05-1.82 4.05-4.05 0-1.03-.39-2.01-1.11-2.77-.02-.02-.04-.05-.06-.07a4.016 4.016 0 0 0-2.88-1.21c-2.23 0-4.05 1.82-4.05 4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.949 19.07-2.54-2.54a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.54 2.54c.29.29.29.77 0 1.06-.14.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.39 19.1a.754.754 0 0 1 0-1.06l2.54-2.54c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.54 2.54c-.15.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 21.52c-2.56-.87-9.88-5.11-9.88-12.83 0-3.5 2.83-6.34 6.31-6.34 1.67 0 3.27.67 4.44 1.84a6.308 6.308 0 0 1 4.44-1.84c3.48 0 6.31 2.84 6.31 6.34 0 1.95-.47 3.82-1.4 5.57a.74.74 0 0 1-.56.39.757.757 0 0 1-.65-.23 4.05 4.05 0 0 0-2.95-1.28c-2.23 0-4.05 1.82-4.05 4.05 0 .99.37 1.95 1.04 2.7.16.18.22.42.17.65-.05.23-.21.43-.42.53-.4.18-.76.33-1.09.44-.23.1-.53.14-.84.14-.31 0-.62-.04-.87-.13zM2.75 8.69c0 6.84 6.57 10.62 8.87 11.41.18.07.57.06.75 0l.09-.03c-.52-.86-.81-1.85-.81-2.87a5.557 5.557 0 0 1 8.79-4.51c.54-1.28.81-2.62.81-4 0-2.67-2.16-4.84-4.81-4.84-1.5 0-2.94.72-3.84 1.93-.28.38-.92.38-1.2 0a4.812 4.812 0 0 0-3.84-1.93c-2.65 0-4.81 2.17-4.81 4.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHeartRemove);
export default __webpack_public_path__ + "static/media/vuesax-outline-heart-remove.c4f4f2718148a324c3947aaf6d184cfa.svg";
export { ForwardRef as ReactComponent };